import { SMILE_CENTERS } from "./brandConfig";
import { normalizeClientType } from "./clientTypes";

export type ProspectContact = {
  full_name: string; email: string | null; phone: string | null;
  center: string | null; client_type: string | null; participants_range: string | null;
};

const key = (value: string) => value.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase();

export function prospectCaseDefaults(prospect: ProspectContact) {
  const [firstName = "", ...lastName] = prospect.full_name.trim().split(/\s+/);
  const center = prospect.center
    ? SMILE_CENTERS.find(c => key(prospect.center!).includes(key(c))) ?? ""
    : "";
  // Une tranche déclarée ne donne pas un effectif exact.
  const count = prospect.participants_range?.trim() ?? "";
  return {
    client_first_name: firstName,
    client_last_name: lastName.join(" "),
    client_email: prospect.email ?? "",
    client_phone: prospect.phone ?? "",
    center,
    client_type: normalizeClientType(prospect.client_type) ?? "",
    participants: /^[1-9]\d*$/.test(count) ? count : "",
  };
}
